export class LongPressSingleton {

  public static inputTouchDelay: number = 0;

  public static getInstance() {
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/directives/long-press/LongPressSingleton.ts